export const changeDelivery = () => ({
  type: `Click change box frequency`,
});
